import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Collapse, Select, Form, Input, Radio, Button } from 'antd';
import { AiOutlinePlusSquare, AiOutlineMinusSquare } from 'react-icons/ai';
import './editProfile.css'
import { heightList, languageList, religionAndCommunityList, qualificationList, workingWithList, occupationList, incomeList, hobbies } from '../../data';
import { useDispatch, useSelector } from 'react-redux';
import { changePersonalProfile } from '../../Redux/features/User/userSlice';
import { useCookies } from 'react-cookie'
import { countryAndcities } from '../../cities';
import { countries } from '../../states.js';


function getCitiesByCountry(countryName) {
    let allCities = [];

    for (let i = 0; i < 152; i++) {
        if (countryAndcities[i].country_name === countryName) {
            allCities = countryAndcities[i].cities;
        }
    }
    return allCities;
}
function getStatesByCountry(countryName) {
    const countryData = countries.find(country => country.country === countryName);
    if (countryData) {
        return countryData.states;
    } else {
        return [];
    }
}
const { Option } = Select;
const { Panel } = Collapse;
const EditPersonalProfile = () => {
    const dispatch = useDispatch();
    const { user } = useSelector(state => state.user);
    // eslint-disable-next-line
    const [cookies, setCookie, removeCookie] = useCookies(['x-auth-token']);
    let data = {
        header: cookies['x-auth-token'],
    }
    const [maritalStatus, setMaritalStatus] = useState(user?.personalDetails?.maritalStatus);
    const [religion, setReligion] = useState('');
    const [community, setCommunity] = useState([]);
    const [citiesList, setCitiesList] = useState([]);
    const [statesList, setStatesList] = useState([]);
    const [haveKids, setHaveKids] = useState(user?.personalDetails?.totalKids > 1 ? true : false);
    const [health, setHealth] = useState(user?.personalDetails?.healthInfo);
    const [disability, setDisability] = useState(user?.personalDetails?.disability === "No" ? false : true);
    const [occupation, setOccupation] = useState(user?.educationAndCareer?.occupation);
    const handleMaritalStatusChange = (value) => {
        setMaritalStatus(value);
    };
    const handlKidsChnage = (value) => {
        setHaveKids(value.target.value);
    };
    const handleDisability = (value) => {
        setDisability(value.target.value);
    };
    const handleReligionChange = (value) => {
        let arr = [];
        religionAndCommunityList.forEach((religionAndCommunity) => {
            if (religionAndCommunity.religion === value) {
                arr = religionAndCommunity.castes;
            }
        })
        setReligion(value);
        setCommunity(arr);
    };

    const [basicInfoForm] = Form.useForm();
    const [religiousBackgroundForm] = Form.useForm();
    const [familyDetailsForm] = Form.useForm();
    const [lifeStyleForm] = Form.useForm();
    const [educationAndCareerForm] = Form.useForm();
    const [aboutForm] = Form.useForm();

    const handleUpdate = () => {
        const dataa = {
            ...basicInfoForm.getFieldsValue(),
            ...religiousBackgroundForm.getFieldsValue(),
            ...familyDetailsForm.getFieldsValue(),
            ...lifeStyleForm.getFieldsValue(),
            ...educationAndCareerForm.getFieldsValue(),
            ...aboutForm.getFieldsValue(),
        }
        dispatch(changePersonalProfile({ ...data, dataa }));
    }


    const getCities = (value) => {
        setCitiesList(getCitiesByCountry(value));
        setStatesList(getStatesByCountry(value));
    }
    useEffect(() => {
        setCitiesList(getCitiesByCountry(user?.personalDetails?.countryLiving));
        setStatesList(getStatesByCountry(user?.personalDetails?.countryLiving));
        //eslint-disable-next-line
    }, [])

    return (
        <div className='editProfile container'>
            <div className='heading row' style={{ color: "grey" }}>
                <div className='col-md-6 head'>Edit Personal Profile</div>
                <div className='col-md-6'>Fields in bold cannot be edited. Please contact  <Link> Customer Care </Link> for any queries</div>
            </div>
            <Collapse
                style={{ background: "transparent" }}
                bordered={false}
                defaultActiveKey={['1']}
                expandIconPosition="right"
                expandIcon={({ isActive }) => isActive ? <AiOutlineMinusSquare size={27} style={{ color: "grey" }} /> : <AiOutlinePlusSquare size={27} style={{ color: "grey" }} />}
            >
                <Panel header="Basic Info" key="1" style={{ fontWeight: "bold", marginBottom: 24, background: "#e2e2df", border: 'none' }}>
                    <div className='row backgroundLight'>
                        <Form form={basicInfoForm} className='m-4 row'>
                            <Form.Item
                                label="First Name"
                                labelCol={{ span: 4 }}
                                wrapperCol={{ span: 6 }}
                                name="firstName"
                                initialValue={user.personalDetails.firstName}
                                rules={[{ required: true, message: 'Please input your first name!' }]}
                            >
                                <Input defaultValue={user?.firstName} />
                            </Form.Item>

                            <Form.Item
                                label="Last Name"
                                labelCol={{ span: 4 }}
                                wrapperCol={{ span: 6 }}
                                name="lastName"
                                initialValue={user.personalDetails.firstName}
                                rules={[{ required: true, message: 'Please input your first name!' }]}
                            >
                                <Input defaultValue={user?.lastName} />
                            </Form.Item>

                            <Form.Item
                                label="Body Type"
                                name="bodyType"
                                labelCol={{ span: 4 }}
                                wrapperCol={{ span: 6 }}
                                defaultValue={user?.personalDetails?.bodyType}
                            >
                                <Select defaultValue={user?.personalDetails?.bodyType} showSearch>
                                    <Option value="Slim">Slim</Option>
                                    <Option value="Athletic">Athletic</Option>
                                    <Option value="Average">Average</Option>
                                    <Option value="slightly Over Weight">slightly Over Weight</Option>
                                    <Option value="Over Weight">Over Weight</Option>
                                </Select>
                            </Form.Item>

                            <Form.Item
                                label="Marital Status"
                                name="maritalStatus"
                                labelCol={{ span: 4 }}
                                wrapperCol={{ span: 6 }}
                            >
                                <Select showSearch value={maritalStatus} defaultValue={maritalStatus} onChange={handleMaritalStatusChange}>
                                    <Option value="Never Married">Never Married</Option>
                                    <Option value="Divorced">Divorced</Option>
                                    <Option value="Widowed">Widowed</Option>
                                    <Option value="Awaiting Divorce">Awaiting Divorce</Option>
                                    <Option value="Annulled">Annulled</Option>
                                </Select>
                            </Form.Item>
                            <Form.Item labelCol={{ span: 4 }}
                                wrapperCol={{ span: 6 }} name="haveKids" label="Do You Have Kids">
                                <Radio.Group defaultValue={user.personalDetails.totalKids > 0 && true} value={haveKids} onChange={handlKidsChnage}>
                                    <Radio value={true}>Yes</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                            </Form.Item>
                            {haveKids && (
                                <Form.Item labelCol={{ span: 4 }}
                                    wrapperCol={{ span: 6 }} defaultValue={user.personalDetails.totalKids} name="totalKids" label="Number of Kids:">
                                    <Select showSearch>
                                        <Option value="1">1</Option>
                                        <Option value="2">2</Option>
                                        <Option value="3+">3+</Option>
                                    </Select>
                                </Form.Item>
                            )}
                            {haveKids && (
                                <Form.Item labelCol={{ span: 4 }}
                                    wrapperCol={{ span: 6 }} defaultValue={user.personalDetails.kidsLiveWithYou} name='kidsLiveWithYou' label="Kids live with you">
                                    <Radio.Group>
                                        <Radio value={true}>Yes</Radio>
                                        <Radio value={false}>No</Radio>
                                    </Radio.Group>
                                </Form.Item>
                            )}
                            {haveKids && (
                                <Form.Item labelCol={{ span: 4 }}
                                    wrapperCol={{ span: 6 }} defaultValue={user.personalDetails.planMoreKids} name='planMoreKids' label="Plan to have more kids?">
                                    <Radio.Group>
                                        <Radio value={true}>Yes</Radio>
                                        <Radio value={false}>No</Radio>
                                    </Radio.Group>
                                </Form.Item>
                            )}
                            <Form.Item labelCol={{ span: 4 }}
                                wrapperCol={{ span: 6 }} name="height" label="Height">
                                <Select defaultValue={user.personalDetails.height} showSearch>
                                    {heightList.map((height, index) => (
                                        <Option key={index} value={height}>{height}</Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Form.Item defaultValue={user.personalDetails.healthInfo} labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="healthInfo" label="Health">
                                <Select defaultValue={user.personalDetails.healthInfo} value={health} onChange={setHealth} showSearch>
                                    <Option value="No Health Problems">No Health Problems</Option>
                                    <Option value="HIV positive" >HIV positive</Option>
                                    <Option value="Diabetes" >Diabetes</Option>
                                    <Option value="Low BP" >Low BP</Option>
                                    <Option value="High BP">High BP</Option>
                                    <Option value="Heart Ailments">Heart Ailments</Option>
                                    <Option value="Other">Other</Option>
                                </Select>
                            </Form.Item>
                            {health === "Other" && <Form.Item name="healthInfoOther" labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} label="Type here about your Health">
                                <Input defaultValue={user.personalDetails.healthInfo} />
                            </Form.Item>}
                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="disability" label="Any Disability">
                                <Radio.Group defaultValue={user.personalDetails.disability === "No" ? false : true} value={disability} onChange={handleDisability}>
                                    <Radio value={true}>Yes</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                            </Form.Item>
                            {disability && <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="disabilityOther" label="Type here about your Disability">
                                <Input defaultValue={user.personalDetails.disability} />
                            </Form.Item>}
                            <Form.Item labelCol={{ span: 4 }}
                                wrapperCol={{ span: 6 }} name="bloodGroup" label="Blood Group">
                                <Select defaultValue={user.personalDetails.bloodGroup} showSearch>
                                    <Option value="A+">A+</Option>
                                    <Option value="A-">A-</Option>
                                    <Option value="B+">B+</Option>
                                    <Option value="B-">B-</Option>
                                    <Option value="AB+">AB+</Option>
                                    <Option value="AB-">AB-</Option>
                                    <Option value="O+">O+</Option>
                                    <Option value="O-">O-</Option>
                                </Select>
                            </Form.Item>

                            <Form.Item labelCol={{ span: 4 }}
                                wrapperCol={{ span: 6 }} name="countryLiving" label="Country Living">
                                <Select defaultValue={user.personalDetails.countryLiving} onChange={getCities} showSearch>
                                    {
                                        countryAndcities.map((country, index) => (
                                            <Option key={index} value={country.country_name}>{country.country_name}</Option>
                                        ))
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item
                                labelCol={{ span: 4 }}
                                wrapperCol={{ span: 6 }}
                                name="stateLiving"
                                label="State Living In"
                                defaultValue={user?.personalDetails?.stateLiving}
                            >
                                <Select showSearch defaultValue={user?.personalDetails?.stateLiving}>
                                    {statesList.map((item, index) => {
                                        return (
                                            <Option key={index} value={item}>{item}</Option>
                                        )
                                    })
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item
                                labelCol={{ span: 4 }}
                                wrapperCol={{ span: 6 }}
                                name="residencyStatus"
                                label="Residency Status"
                                defaultValue={user?.personalDetails?.residencyStatus}
                            >
                                <Select showSearch defaultValue={user?.personalDetails?.residencyStatus}>
                                    <Option value="Citizen / Permanent Resident">Citizen / Permanent Resident</Option>
                                    <Option value="Work Visa">Work Visa</Option>
                                    <Option value="Student Visa">Student Visa</Option>
                                    <Option value="Tourist Visa">Tourist Visa</Option>
                                </Select>
                            </Form.Item>
                            <Form.Item labelCol={{ span: 4 }}
                                wrapperCol={{ span: 6 }} name="cityLiving" label="City Living">
                                <Select defaultValue={user.personalDetails.cityLiving} showSearch>
                                    {
                                        citiesList?.map((city, index) => (
                                            <Option key={index} value={city}>{city}</Option>
                                        ))
                                    }
                                </Select>
                            </Form.Item>

                            <Form.Item labelCol={{ span: 4 }}
                                wrapperCol={{ span: 6 }} name="grewUpIn" label="Country Grew Up In">
                                <Select defaultValue={user.personalDetails.grewUpIn} showSearch>
                                    {
                                        countryAndcities.map((country, index) => (
                                            <Option key={index} value={country.country_name}>{country.country_name}</Option>
                                        ))
                                    }
                                </Select>
                            </Form.Item>
                        </Form>
                    </div>
                </Panel>
                <Panel header="Religious Background" key="2" style={{ fontWeight: "bold", marginBottom: 24, background: "#e2e2df", border: 'none' }}>
                    <div className='row backgroundLight'>
                        <Form form={religiousBackgroundForm} className='m-4 row'>
                            <Form.Item
                                label="Religion"
                                name="religion"
                                labelCol={{ span: 4 }}
                                wrapperCol={{ span: 6 }}
                            >
                                <Select defaultValue={user.personalDetails.religion} showSearch value={religion} onChange={handleReligionChange}>
                                    {
                                        religionAndCommunityList.map((religionAndCommunity, index) => (
                                            <Option key={index} value={religionAndCommunity.religion}>{religionAndCommunity.religion}</Option>
                                        ))
                                    }
                                </Select>
                            </Form.Item>

                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="community" label="Community">
                                <Select defaultValue={user.personalDetails.community} showSearch>
                                    {
                                        community.map((community, index) => (
                                            <Option key={index} value={community}>{community}</Option>
                                        ))
                                    }
                                </Select>
                            </Form.Item>

                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="subCommunity" label="Sub Community">
                                <Input defaultValue={user.personalDetails.subCommunity} />
                            </Form.Item>

                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="motherTongue" label="Mother Tongue">
                                <Select defaultValue={user.personalDetails.motherTongue} showSearch>
                                    {
                                        languageList.map((motherTongue, index) => (
                                            <Option key={index} value={motherTongue}>{motherTongue}</Option>
                                        ))
                                    }
                                </Select>
                            </Form.Item>
                        </Form>
                    </div>
                </Panel>
                <Panel header="Family" key="3" style={{ fontWeight: "bold", marginBottom: 24, background: "#e2e2df", border: 'none' }}>
                    <div className='row backgroundLight'>
                        <Form form={familyDetailsForm} className="m-4 row">
                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="fatherStatus" label="Father Status">
                                <Select defaultValue={user.familyDetails.fatherStatus} showSearch>
                                    <Option value="Alive">Alive</Option>
                                    <Option value="Deceased">Deceased</Option>
                                </Select>
                            </Form.Item>

                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="motherStatus" label="Mother Status">
                                <Select defaultValue={user.familyDetails.motherStatus} showSearch>
                                    <Option value="Alive">Alive</Option>
                                    <Option value="Deceased">Deceased</Option>
                                </Select>
                            </Form.Item>

                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="familyLocation" label="Family Location">
                                <Select defaultValue={user.familyDetails.familyLocation} showSearch>
                                    {countryAndcities.map((country, index) => (
                                        <Option key={index} value={country.country_name}>{country.country_name}</Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="brothers" label="Number of Brothers">
                                <Select defaultValue={user.familyDetails.brothers} showSearch>
                                    <Option value="0">0</Option>
                                    <Option value="1">1</Option>
                                    <Option value="2">2</Option>
                                    <Option value="3">3</Option>
                                    <Option value="4">4</Option>
                                    <Option value="5">5</Option>
                                    <Option value="6+">6+</Option>
                                </Select>
                            </Form.Item>

                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="sisters" label="Number of Sisters">
                                <Select defaultValue={user.familyDetails.sisters} showSearch>
                                    <Option value="0">0</Option>
                                    <Option value="1">1</Option>
                                    <Option value="2">2</Option>
                                    <Option value="3">3</Option>
                                    <Option value="4">4</Option>
                                    <Option value="5">5</Option>
                                    <Option value="6+">6+</Option>
                                </Select>
                            </Form.Item>

                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="familyType" label="Family Type">
                                <Radio.Group defaultValue={user.familyDetails.familyType}>
                                    <Radio value="Joint">Joint</Radio>
                                    <Radio value="Nuclear">Nuclear</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="familyValues" label="Family Values">
                                <Radio.Group defaultValue={user.familyDetails.familyValues}>
                                    <Radio value="Traditional">Traditional</Radio>
                                    <Radio value="Moderate">Moderate</Radio>
                                    <Radio value="Liberal">Liberal</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="familyAffluence" label="Family Affluence">
                                <Select defaultValue={user.familyDetails.familyAffluence} showSearch>
                                    <Option value="Affluent">Affluent</Option>
                                    <Option value="Upper Middle Class">Upper Middle Class</Option>
                                    <Option value="Middle Class">Middle Class</Option>
                                    <Option value="Lower Middle Class">Lower Middle Class</Option>
                                    <Option value="Poor">Poor</Option>
                                </Select>
                            </Form.Item>
                        </Form>
                    </div>
                </Panel>
                <Panel header="Education & Career" key="4" style={{ fontWeight: "bold", marginBottom: 24, background: "#e2e2df", border: 'none' }}>
                    <div className='row backgroundLight'>
                        <Form form={educationAndCareerForm} className="m-4 row">
                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="qualification" label="Highest Education">
                                <Select defaultValue={user.educationAndCareer.qualification} showSearch >
                                    {qualificationList.map((qualification, index) => (
                                        <Option key={index} value={qualification}>
                                            {qualification}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="college" label="College Attend">
                                <Input defaultValue={user.educationAndCareer.college} />
                            </Form.Item>

                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="workingWith" label="Working With">
                                <Select defaultValue={user.educationAndCareer.workingWith} showSearch >
                                    {workingWithList.map((workingWith, index) => (
                                        <Option key={index} value={workingWith}>
                                            {workingWith}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <div style={{fontSize:12}} className='text-center text-danger'>*if your occupation is not here then select Other and write your desired Occupation</div>
                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="occupation" label="Working As">
                                <Select defaultValue={user.educationAndCareer.occupation} onChange={setOccupation} showSearch >
                                    {occupationList.map((occupation, index) => (
                                        <Option key={index} value={occupation}>
                                            {occupation}
                                        </Option>
                                    ))}
                                    <Option value="Other">Other</Option>
                                </Select>
                            </Form.Item>
                            {occupation === "Other" && <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="otherOccupation" label="Type here">
                                <Input defaultValue={user.educationAndCareer.occupation} />
                            </Form.Item>}
                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="company" label="Employeer Name">
                                <Input defaultValue={user.educationAndCareer.company} />
                            </Form.Item>
                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 6 }} name="annualIncome" label="Annual Income">
                                <Select defaultValue={user.educationAndCareer.annualIncome} showSearch >
                                    {incomeList.map((income, index) => (
                                        <Option key={index} value={income}>
                                            {income}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Form>
                    </div>
                </Panel>
                <Panel header="Life Style" key="5" style={{ fontWeight: "bold", marginBottom: 24, background: "#e2e2df", border: 'none' }}>
                    <div className='row backgroundLight'>
                        <Form form={lifeStyleForm} className="m-4 row">
                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 12 }} name="diet" label="Diet">
                                <Radio.Group defaultValue={user.personalDetails.diet}>
                                    <Radio value="Veg">Veg</Radio>
                                    <Radio value="Non-Veg">Non-Veg</Radio>
                                    <Radio value="Occasionally Veg">Occasionally Veg</Radio>
                                    <Radio value="Occasionally Non-Veg">Occasionally Non-Veg</Radio>
                                    <Radio value="Eggetarian">Eggetarian</Radio>
                                    <Radio value="Vegan">Vegan</Radio>
                                    <Radio value="Other">Other</Radio>
                                </Radio.Group>
                            </Form.Item>
                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 12 }} name="smoke" label="Do You Smoke?">
                                <Radio.Group defaultValue={user.personalDetails.smoke}>
                                    <Radio value="No">No</Radio>
                                    <Radio value="Yes">Yes</Radio>
                                    <Radio value="Occasionally">Occasionally</Radio>
                                </Radio.Group>
                            </Form.Item>
                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 12 }} name="drink" label="Do You Drink?">
                                <Radio.Group defaultValue={user.personalDetails.drink}>
                                    <Radio value="No">No</Radio>
                                    <Radio value="Yes">Yes</Radio>
                                    <Radio value="Occasionally">Occasionally</Radio>
                                </Radio.Group>
                            </Form.Item>
                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 12 }} name="drug" label="Do You Take Drugs?">
                                <Radio.Group defaultValue={user.personalDetails.drug}>
                                    <Radio value="No">No</Radio>
                                    <Radio value="Yes">Yes</Radio>
                                    <Radio value="Occasionally">Occasionally</Radio>
                                </Radio.Group>
                            </Form.Item>
                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 18 }} name="hobbies" label="Interests And Hobbies">
                                <Select mode="multiple" defaultValue={user?.personalDetails?.interests?.hobbies} >
                                    {hobbies.map((hobby, index) => (
                                        <Option key={index} value={hobby.value}>
                                            {hobby.value}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Form>
                    </div>
                </Panel>
                <Panel header="More about Yourself, Partner and Family" key="6" style={{ fontWeight: "bold", marginBottom: 24, background: "#e2e2df", border: 'none' }}>
                    <div className='row backgroundLight'>
                        <Form form={aboutForm} className="m-4 row">
                            Personality, Family Details, Career, Partner Expectations etc.
                            <Form.Item labelCol={{ span: 4 }} wrapperCol={{ span: 12 }} name="aboutMe" label="About Yourself">
                                <Input.TextArea defaultValue={user.personalDetails.aboutMe} rows={4} />
                            </Form.Item>
                        </Form>
                    </div>
                </Panel>
            </Collapse>

            <div className="row justify-content-center">
                <Button onClick={handleUpdate} type="primary" className="login-form-button" style={{ width: 200, marginTop: 20 }}>
                    Update
                </Button>
            </div>
        </div>
    )
}

export default EditPersonalProfile
